module.exports = __webpack_public_path__ + "05_veryshort_gray.a35770cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_veryshort_gray.png
// module id = 3BVY
// module chunks = 0